module.exports = __webpack_public_path__ + "img/pay-failed-icon.e83a7728.png";